import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import LeadTypeView from '../components/version-4/viewForms/LeadTypeView'
import { useLeadType } from '../hooks/CompanyConfiguration/useLeadType'
import { ROUTES } from '../shared/constants'

function ViewLeadType() {
  const { leadType, getLeadType } = useLeadType()
  const params = useParams()

  React.useEffect(() => {
    getLeadType({ leadTypeId: params.leadTypeId })
  }, [params.leadTypeId])

  return (
    <Layout heading="Lead Type" heading2="Info" url1={ROUTES.LEAD_TYPE} none>
      {leadType ? (
        <HeaderTabLayout
          heading="Lead Type"
          content={<LeadTypeView leadType={leadType} />}
          view
          url={`/edit-leadType/${params.leadTypeId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewLeadType
